import type { Facility } from '../../utils/utils';

export default function LicenseCell({ facility }: { facility: Facility }) {
    return (
        <span className="text-xs tabular-nums text-foreground">
            {facility.active_licenses}
            <span className="text-muted-foreground"> / {facility.licenses}</span>
        </span>
    );
}
